
import styled from 'styled-components';

export const LogoWrapper = styled.div`
  padding: 35px;
  height: 80px;
  display: flex;
  align-items: center!important;
  justify-content: center;


  @media (max-width: 1400px) {
    padding: 15px;

  }
`;
